import React from "react";
import { useNavigate} from 'react-router-dom'
import PremierSlider from "react-slick";

import settings from "../../config/PosterCarousal.config";

import Poster from "../Poster/Poster.component"

import {BiSolidRightArrow} from "react-icons/bi";

const PosterSlider = (props) => {
  const navigate = useNavigate()
  function goToPlays(){
    navigate("/plays");
  }
  return (
    <>
      
        <div className=" mt-16  flex justify-between items-center ">
         <div> <h3 className={`text-2xl font-bold ${props.isDark ? "text-white font bold" : "text-grey-700"}`}>{props.title}</h3></div>
        <a>
            <span onClick={goToPlays} className="hover:underline flex items-center text-red-500 text-sm hover:cursor-pointer pr-6">See All  <BiSolidRightArrow className="animate-pulse hover:animate-none text-md hover:text-lg text-gray-400 border-1 border-black hover:text-red-500 " />
          </span>
          </a>
          
      </div>
      <PremierSlider {...settings}>
        {props.images.map((image) => (
          <Poster{...image} isDark={props.isDark} />
        ))}
      </PremierSlider>
    </>
  )
};

export default PosterSlider;